export const APP_ROUTES = {
  ROOT: '/',
  ABOUT_US: '/about-us',
  ADMIN: '/admin',
  ADMIN_LOGIN: '/admin/login',
  RESERVATION: '/reservation',
  RESERVATION_HISTORY: '/reservation/history',
  PROFILE: '/profile',
  NEWS: '/news',
  INQUIRY: '/inquiry',
} as const;
